<template>
	<div>
		<div class="vx-row w-full" v-if="isLoad" style="margin-left: 22px">
			<span class="title-big w-full">FACTURE(S) :</span>
			<span class="loader" style="font-size: 14px"
				><b>Chargementz en cours, veuillez patienter</b></span
			>
		</div>
		<div
			class="vx-row w-full"
			v-if="error && !isLoad"
			style="margin-left: 22px"
		>
			<span class="title-big w-full loader">FACTURE(S) :</span>
			<span style="font-size: 14px"
				><b
					>Le client n'est pas associé au logiciel de facturation, merci de
					contacter un super administrateur.</b
				></span
			>
		</div>
		<div
			class="vx-row w-full"
			v-if="!isLoad && !error"
			style="margin-left: 22px"
		>
			<span class="title-big w-full">FACTURE(S) :</span>
			<span style="font-size: 14px"
				>{{ invoices.length }}, DONT
				{{ getUnpaidInvoice(invoices).length }}
				EN RETARD. (TOTAL HT: {{ getTotal("HT") }} / TOTAL TTC:
				{{ getTotal("TTC") }})</span
			>
		</div>
		<vs-table
			v-if="!isLoad && !error"
			:data="invoices"
			class="mt-4 w-full"
			pagination
			:max-items="10"
			noDataText="Pas de facture émise"
		>
			<template slot="thead">
				<vs-th style="width: 40px">
					<div
						@click.stop="toggleAllExpand()"
						class="expand-icon-wrapper"
						style="
							cursor: pointer !important;
							display: flex;
							justify-content: center;
							pointer-events: auto;
							padding: 5px;
							user-select: none;
						"
					>
						<vs-icon
							:icon="
								allExpanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right'
							"
							size="small"
							style="pointer-events: none"
						/>
					</div>
				</vs-th>
				<vs-th sort-key="invoice_date" class="pdl0">Date de la facture</vs-th>
				<vs-th sort-key="invoice_id" class="pdl0">N° de la facture</vs-th>
				<vs-th sort-key="HT_price" class="text-right pdl0">Montant HT</vs-th>
				<vs-th sort-key="TTC_price" class="text-right pdl0">Montant TTC</vs-th>
				<vs-th sort-key="is_paid" class="pdl0"
					><div class="w-full text-center">STATUT</div></vs-th
				>
				<vs-th v-if="exportInvoiceDetail"></vs-th>
			</template>

			<template slot-scope="{ data }">
				<tbody
					v-for="(row, index) in data"
					:key="'tbody-' + (row.invoice_number || index)"
				>
					<vs-tr
						@click="toggleExpandIfNotInteractive($event, index)"
						style="cursor: pointer"
					>
						<vs-td style="width: 40px; text-align: center">
							<div
								@click.stop="toggleExpand(index)"
								class="expand-icon-wrapper"
								style="
									cursor: pointer !important;
									display: flex;
									justify-content: center;
									padding: 5px;
									user-select: none;
								"
							>
								<vs-icon
									:icon="
										expandedRows[index]
											? 'keyboard_arrow_down'
											: 'keyboard_arrow_right'
									"
									size="small"
									style="pointer-events: none"
								/>
							</div>
						</vs-td>
						<vs-td :data="row.date">{{
							getDateToFrenchFormatFourDigit(row.date)
						}}</vs-td>
						<vs-td :data="row.invoice_number"
							><a target="_blank" :href="row.file_url">{{
								row.invoice_number
							}}</a></vs-td
						>
						<vs-td :data="row.currency_amount_before_tax"
							><vs-spacer />{{
								convertNumberToFrenchCurrency(
									row.currency_amount_before_tax / (row.exchange_rate || 1)
								)
							}}</vs-td
						>
						<vs-td :data="row.currency_amount"
							><vs-spacer />{{
								convertNumberToFrenchCurrency(
									row.currency_amount / (row.exchange_rate || 1)
								)
							}}</vs-td
						>
						<vs-td :data="row.paid" class="text-center pdl0">{{
							getStatus(row)
						}}</vs-td>
						<vs-td v-if="exportInvoiceDetail" class="text-center pdl0"
							><vs-button
								@click="exportInvoiceDetails(row)"
								@click.stop="event.stopPropagation()"
								>Import</vs-button
							></vs-td
						>
					</vs-tr>
					<tr
						v-if="expandedRows[index]"
						:key="'expand-' + index"
						class="expand-row"
					>
						<td :colspan="exportInvoiceDetail ? 8 : 7" style="padding: 0">
							<div style="width: 100%; display: flex">
								<vs-table :data="row.line_items" auto-resize class="w-full">
									<template slot="thead">
										<vs-th></vs-th>
										<vs-th class="text-center pdl0">Service</vs-th>
										<vs-th class="text-center pdl0">Description</vs-th>
										<vs-th class="text-right"
											><vs-spacer />Prix par unité HT</vs-th
										>
										<vs-th class="text-center pdl0"
											><vs-spacer />Quantité<vs-spacer
										/></vs-th>
										<vs-th class="text-right"><vs-spacer />Prix Total HT</vs-th>
										<vs-th v-if="doImport" class="text-right"
											><vs-spacer
										/></vs-th>
									</template>

									<template slot-scope="{ data }">
										<vs-tr :key="index" v-for="(item, index) in data">
											<vs-td style="width: 38px"></vs-td>
											<vs-td>{{ item.label }}</vs-td>
											<vs-td>{{ item.description }}</vs-td>
											<vs-td
												class="pdl0 text-right"
												style="padding-right: 12px"
												>{{
													convertNumberToFrenchCurrency(
														item.raw_currency_unit_price /
															(row.exchange_rate || 1)
													)
												}}</vs-td
											>
											<vs-td class="pdl0 text-center">{{
												Number(item.quantity)
											}}</vs-td>
											<vs-td
												class="pdl0 text-right"
												style="padding-right: 12px"
												>{{
													convertNumberToFrenchCurrency(
														item.currency_price_before_tax /
															(row.exchange_rate || 1)
													)
												}}</vs-td
											>
											<vs-td
												v-if="doImport"
												class="pdl0 text-right"
												style="padding-right: 12px"
												><vs-button @click="exportInvoiceItemDetails(item)"
													>Import</vs-button
												></vs-td
											>
										</vs-tr>
									</template>
								</vs-table>
							</div>
						</td>
					</tr>
				</tbody>
			</template>
		</vs-table>
	</div>
</template>

<script>
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import store from "@/store/store";

export default {
	name: "FacturationTable",
	components: {},
	props: {
		contract_id: Number,
		doImport: {
			type: Boolean,
			default: true,
		},
		error: Boolean,
		list: Array,
		loader: Boolean,
		refreshKey: {
			type: Number,
			default: 0,
		},
		exportInvoiceDetail: {
			type: Boolean,
			default: false,
		},
	},
	mixins: [dbFieldConvertor, utilsMixin],
	data() {
		return {
			isLoad: true,
			invoices: [],
			apiUrl: store.state.backendApiUrl,
			expandedRows: {},
			allExpanded: false,
		};
	},
	created() {
		console.log("message CRSTED");
		this.getInvoices();
	},
	watch: {
		refreshKey: function (data) {
			//console.log(data);
		},
	},
	computed: {},
	updated() {},
	methods: {
		toggleExpand(index) {
			this.$set(this.expandedRows, index, !this.expandedRows[index]);
		},
		toggleAllExpand() {
			this.allExpanded = !this.allExpanded;
			const newExpandedRows = {};
			if (this.allExpanded) {
				// Expand all rows
				for (let i = 0; i < this.invoices.length; i++) {
					newExpandedRows[i] = true;
				}
			}
			// If collapsing all, newExpandedRows remains empty
			this.expandedRows = newExpandedRows;
		},
		toggleExpandIfNotInteractive(event, index) {
			// Check if the clicked element or its parents are interactive elements
			const interactiveElements = [
				"BUTTON",
				"INPUT",
				"SELECT",
				"TEXTAREA",
				"A",
				"VS-BUTTON",
			];
			let element = event.target;

			// Walk up the DOM tree to check for interactive elements
			while (element && element !== event.currentTarget) {
				if (interactiveElements.includes(element.tagName)) {
					return; // Don't expand if clicking on an interactive element
				}
				// Check for click handlers that stop propagation
				if (element.onclick || element.getAttribute("@click")) {
					return;
				}
				element = element.parentElement;
			}

			// If we got here, it's safe to toggle expand
			this.toggleExpand(index);
		},
		exportInvoiceDetails(row) {
			this.$emit("export-invoice", row);
		},
		exportInvoiceItemDetails(row) {
			this.$emit("export-invoice-item", row);
		},
		getInvoices() {
			this.$http
				.get(this.apiUrl + "qb/invoices_by_contract/" + this.$props.contract_id)
				.then((result) => {
					this.invoices = result.data;
					this.isLoad = false;
				})
				.catch((error) => {
					console.log(error);
				});
		},

		getStatus(row) {
			return row.status;
		},
		/**
		 * Get unpaid invoices
		 * @param {Array} invoices
		 */
		getUnpaidInvoice(invoices) {
			let unpaids = [];
			invoices.forEach((invoice) => {
				if (invoice.status) {
					if (!invoice.status.includes("Payé")) unpaids.push(invoice);
				}
			});

			return unpaids;
		},

		getStatusFrenchName(name) {
			switch (name) {
				case "paid":
					return "Payé";
				case "upcoming":
					return "A venir";
				case "late":
					return "En retard";
				case "credit_note":
					return "Avoir";
				case "partially_cancelled":
					return "Annulé";
				default:
					return "";
			}
		},

		getTotal(type) {
			const field =
				type == "HT" ? "currency_amount_before_tax" : "currency_amount";
			if (this.invoices.length === 0) return "0 €";
			const total = this.invoices.reduce((sum, inv) => {
				return sum + Number(inv[field]) / (Number(inv.exchange_rate) || 1);
			}, 0);
			return this.convertNumberToFrenchCurrency(total);
		},
	},
};
</script>

<style scoped>
th > * {
	text-transform: uppercase;
}

.tr-expand > td {
	padding-left: 0 !important;
}

.expand-row td {
	background-color: #ffffffff;
	padding: 20px !important;
}

.expand-icon-wrapper:hover {
	background-color: rgba(0, 0, 0, 0.05);
	border-radius: 4px;
}

div.content-tr-expand {
	padding: 0;
}

.expand-row td {
	background-color: #ffffffff;
	padding: 20px !important;
}

.expand-icon-wrapper:hover {
	background-color: #f0f0f0;
	border-radius: 4px;
}
.loader:after {
	overflow: hidden;
	display: inline-block;
	vertical-align: bottom;
	animation: ellipsis 1.5s infinite;
	content: "......";
	font-weight: bold;
}
@keyframes ellipsis {
	from {
		width: 2px;
	}
	to {
		width: 15px;
	}
}
</style>
